/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Organization role of the uploader
 * @export
 * @enum {string}
 */
export enum Role {
  Personal = 'personal',
  Clinic = 'clinic',
  Maintenance = 'maintenance',
  Marsi = 'marsi',
  Tester = 'tester',
  Commercial = 'commercial',
  Distributor = 'distributor',
  SpecialistClinic = 'specialist_clinic',
}
